// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;




export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65')
];

export const server_loads = [];

export const dictionary = {
		"/(app)": [9,[2]],
		"/(app)/account-monitor": [10,[2]],
		"/(app)/admin": [11,[2,3]],
		"/(app)/admin/access": [12,[2,3]],
		"/(app)/admin/analytics": [13,[2,3]],
		"/(app)/admin/analytics/[tab]": [14,[2,3]],
		"/(app)/admin/evaluations": [15,[2,3]],
		"/(app)/admin/evaluations/[tab]": [16,[2,3]],
		"/(app)/admin/functions": [17,[2,3]],
		"/(app)/admin/functions/create": [18,[2,3]],
		"/(app)/admin/functions/edit": [19,[2,3]],
		"/(app)/admin/qianchuan": [20,[2,3]],
		"/(app)/admin/settings": [21,[2,3]],
		"/(app)/admin/settings/[tab]": [22,[2,3]],
		"/(app)/admin/users": [23,[2,3]],
		"/(app)/admin/users/[tab]": [24,[2,3]],
		"/auth": [62],
		"/(app)/automations": [25,[2,4]],
		"/(app)/automations/[id]": [26,[2,4]],
		"/(app)/calendar": [28,[2]],
		"/(app)/channels/[id]": [29,[2]],
		"/(app)/c/[id]": [27,[2]],
		"/(app)/douyin-content": [30,[2]],
		"/(app)/douyin-rankings": [31,[2]],
		"/error": [63],
		"/(app)/experts": [32,[2]],
		"/(app)/folders/[folderId]": [33,[2]],
		"/(app)/home": [34,[2,5]],
		"/(app)/lucknote": [35,[2]],
		"/(app)/notes": [36,[2,6]],
		"/(app)/notes/new": [38,[2,6]],
		"/(app)/notes/[id]": [37,[2,6]],
		"/(app)/playground": [39,[2,7]],
		"/(app)/playground/completions": [40,[2,7]],
		"/(app)/playground/images": [41,[2,7]],
		"/(app)/product-selection": [42,[2]],
		"/(app)/qianchuan-plans": [43,[2]],
		"/(app)/rule-center": [44,[2]],
		"/s/[id]": [64],
		"/watch": [65],
		"/(app)/workspace": [45,[2,8]],
		"/(app)/workspace/functions/create": [46,[2,8]],
		"/(app)/workspace/knowledge": [47,[2,8]],
		"/(app)/workspace/knowledge/create": [49,[2,8]],
		"/(app)/workspace/knowledge/[id]": [48,[2,8]],
		"/(app)/workspace/models": [50,[2,8]],
		"/(app)/workspace/models/create": [51,[2,8]],
		"/(app)/workspace/models/edit": [52,[2,8]],
		"/(app)/workspace/prompts": [53,[2,8]],
		"/(app)/workspace/prompts/create": [55,[2,8]],
		"/(app)/workspace/prompts/[id]": [54,[2,8]],
		"/(app)/workspace/skills": [56,[2,8]],
		"/(app)/workspace/skills/create": [57,[2,8]],
		"/(app)/workspace/skills/edit": [58,[2,8]],
		"/(app)/workspace/tools": [59,[2,8]],
		"/(app)/workspace/tools/create": [60,[2,8]],
		"/(app)/workspace/tools/edit": [61,[2,8]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);